import React from 'react';
import { useThemeClasses } from '../../../hooks/useThemeClasses';

export default function ColorMatchSection({ listing, compact = false }) {
  const { isDark, sc } = useThemeClasses();
  const vehicleColor = listing?.vehicleColor;
  const hasColor = listing?.colorDataAvailable !== false && vehicleColor?.name;

  return (
    <section className={`${sc('pdpPanel')} ${compact ? 'p-3 sm:p-4' : ''}`}>
      <p className={`text-[11px] font-bold uppercase tracking-[0.15em] ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
        Color match
      </p>

      {hasColor ? (
        <div className="mt-3 flex flex-wrap items-center gap-3">
          <span
            className={`h-8 w-8 shrink-0 rounded-full border-2 shadow-inner ${isDark ? 'border-slate-500' : 'border-slate-300'}`}
            style={{ backgroundColor: vehicleColor.hex || '#94a3b8' }}
            aria-hidden
          />
          <p className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>
            {vehicleColor.label || `Your car: ${vehicleColor.name}`}
          </p>
          {listing.colorMatchType === 'exact' && (
            <span
              className={`rounded-full border px-3 py-1 text-xs font-bold ${
                isDark
                  ? 'border-emerald-600/50 bg-emerald-950/40 text-emerald-300'
                  : 'border-emerald-200 bg-emerald-50 text-emerald-800'
              }`}
            >
              Exact Match
            </span>
          )}
          {listing.colorMatchType === 'paintable' && (
            <span
              className={`rounded-full border px-3 py-1 text-xs font-bold ${
                isDark
                  ? 'border-amber-600/50 bg-amber-950/40 text-amber-300'
                  : 'border-amber-200 bg-amber-50 text-amber-900'
              }`}
            >
              Can Be Painted
            </span>
          )}
        </div>
      ) : (
        <p className={`mt-3 text-sm leading-relaxed ${isDark ? 'text-amber-200/90' : 'text-amber-800'}`}>
          {listing?.colorDisclaimer || 'Verify color before ordering.'}
        </p>
      )}

      {listing?.sellerColorName && (
        <p className={`mt-2 text-xs ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
          Part colour:{' '}
          <span className={isDark ? 'text-slate-300' : 'text-slate-700'}>{listing.sellerColorName}</span>
          {listing.sellerColorCode ? ` (${listing.sellerColorCode})` : ''}
        </p>
      )}
    </section>
  );
}
